import React, { memo } from 'react';
import { string, bool, func, oneOfType, node } from 'prop-types';

import ErrorMessage from 'components/ErrorMessage';

const FormInput = ({
  type,
  testId,
  autoComplete,
  label,
  name,
  register,
  required,
  placeholder,
  className,
  subtitle,
  error,
  inputClassName,
  labelClassName,
  inputWrapperClassName,
  isDisabled,
  prefix,
  ...rest
}) => {
  return (
    <label
      htmlFor={name}
      className={`flex flex-1 flex-col lg:items-center mb-4 lg:flex-row ${className}`}
    >
      <div className={`label ${labelClassName}`}>{label}</div>
      <div className={`input-form-wrapper ${inputWrapperClassName}`}>
        <div className="relative">
          {!!prefix && (
            <span className="absolute w-11 h-auto top-0 bottom-0 flex items-center justify-center rounded-l-md border-r border-gray-300 text-gray-400 font-light">
              {prefix}
            </span>
          )}
          <input
            {...rest}
            {...register(name, { required })}
            autoComplete={autoComplete}
            id={name}
            type={type}
            className={`input input-full-border ${inputClassName} ${
              prefix ? 'pl-14' : ''
            } ${!!error ? 'error' : ''}`}
            data-testid={testId}
            placeholder={placeholder}
            disabled={isDisabled}
          />
        </div>
        {subtitle && (
          <p className="text-xs text-gray-400 w-full mt-1">{subtitle}</p>
        )}
        {!!error && <ErrorMessage message={error} />}
      </div>
    </label>
  );
};

FormInput.propTypes = {
  className: string,
  labelClassName: string,
  inputClassName: string,
  inputWrapperClassName: string,
  testId: string,
  type: string,
  name: string,
  label: oneOfType([string, node]),
  autoComplete: string,
  register: func,
  required: bool,
  placeholder: string,
  subtitle: string,
  error: string,
  isDisabled: bool,
  prefix: string,
};
FormInput.defaultProps = {
  className: '',
  inputClassName: '',
  inputWrapperClassName: '',
  labelClassName: 'pb-1 lg:pb-0 lg:w-4/12',
  testId: 'input',
  type: 'text',
  label: null,
  name: 'input',
  autoComplete: 'new-password',
  required: false,
  register: () => null,
  placeholder: null,
  subtitle: null,
  error: null,
  isDisabled: false,
};

export default memo(FormInput);
